module.exports = "<div id=\"generic-notification-holder\" style=\"display: none\">\n    <%= feedback %>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./js/common/templates/notifications/LiveClassFeedbackNotificationWrapper.html
// module id = 1130
// module chunks = 27 28 29